import * as api from '../lib/api';
import { makeGrowerPath } from '../lib/api/utils';

export function interpolate(aaids) {
  return api.post(
    makeGrowerPath('/soil'),
    aaids.map((aaid) => ({ aaid })),
  );
}
